import { Check, Copy } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'

// The `link XXXX-XXXX` command with a copy button. Falls back to a selectable
// code when the clipboard is unavailable.
export function CopyCommand({ command, ariaLabel }: { command: string; ariaLabel: string }) {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const timer = window.setTimeout(() => setCopied(false), 2000)
    return () => window.clearTimeout(timer)
  }, [copied])

  async function copy() {
    try {
      await navigator.clipboard.writeText(command)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="flex items-center gap-2 rounded-md border border-border bg-background px-3 py-2">
      <code aria-label={ariaLabel} className="min-w-0 flex-1 truncate font-mono text-sm text-foreground">
        {command}
      </code>
      <Button type="button" variant="ghost" size="icon-sm" aria-label={copied ? 'Copied' : 'Copy command'} onClick={copy}>
        {copied ? <Check aria-hidden="true" className="size-4" /> : <Copy aria-hidden="true" className="size-4" />}
      </Button>
    </div>
  )
}
